import { DatePicker, DatePickerProps } from "antd";

interface IInputDateProps extends DatePickerProps {

}

export default function InputDate ({
    showTime,
    ...props
}:IInputDateProps) {
    return <DatePicker
        {...props}
        format={props.format === undefined ? {
                format : showTime === true ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY",
                type: 'mask'
            } : props.format
        }
        showTime={showTime}
    />
}